module.exports = __webpack_public_path__ + "static/media/show_icon.3caccb00.svg";